import { RESOURCE_RATE } from 'enums/extensionShortIdEnum';
import { COLUMN_TYPES_ENUM, RATE_TYPE_COLUMNS, TIME_TYPE_COLUMNS } from 'modules/report/enums/columnTypeEnum';
import * as columnUnitTypes from 'modules/report/enums/columnUnitTypeEnum';
import { displayDateState } from 'modules/report/utils/columnHelper';

/**
 * @param {object} dateState
 *
 * @returns {Array}
 */
export default dateState => [
    {
        id: 'externalReportedSpendBetween',
        display: `${displayDateState(dateState, false, false)} Spend`,
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time',
        displayColumnType: 'spend',
        displayRateType: 'external rate',
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.EXTERNAL,
        heatMapSupport: true,
    },
    {
        id: 'externalReportedSpendPrevious',
        display: `Previous Spend (${displayDateState(dateState, false, false)})`,
        displayTimeType: 'Reported Time',
        displayColumnType: 'spend',
        displayRateType: 'external rate',
        unitType: columnUnitTypes.CURRENCY.value,
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.EXTERNAL,
        heatMapSupport: true,
    },
    {
        id: 'externalReportedSpendAfter',
        display: `Next Spend (${displayDateState(dateState, false, false)})`,
        displayTimeType: 'Reported Time',
        displayColumnType: 'spend',
        displayRateType: 'external rate',
        unitType: columnUnitTypes.CURRENCY.value,
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.EXTERNAL,
        heatMapSupport: true,
    },
    {
        id: 'externalReportedSpendToDate',
        display: 'Spend To Date',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time',
        displayColumnType: 'spend',
        displayRateType: 'external rate',
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.EXTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'externalReportedSpendFuture',
        display: 'Future Spend',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time',
        displayColumnType: 'spend',
        displayRateType: 'external rate',
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.EXTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'externalReportedSpendAllTime',
        display: 'All Time Spend',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time',
        displayColumnType: 'spend',
        displayRateType: 'external rate',
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.EXTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'internalReportedSpendBetween',
        display: `${displayDateState(dateState, false, false)} Spend`,
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time',
        displayColumnType: 'spend',
        displayRateType: 'internal rate',
        extensions: [RESOURCE_RATE],
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.INTERNAL,
        heatMapSupport: true,
    },
    {
        id: 'internalReportedSpendPrevious',
        display: `Previous Spend (${displayDateState(dateState, false, false)})`,
        displayTimeType: 'Reported Time',
        displayColumnType: 'spend',
        displayRateType: 'internal rate',
        unitType: columnUnitTypes.CURRENCY.value,
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.INTERNAL,
        heatMapSupport: true,
    },
    {
        id: 'internalReportedSpendAfter',
        display: `Next Spend (${displayDateState(dateState, false, false)})`,
        displayTimeType: 'Reported Time',
        displayColumnType: 'spend',
        displayRateType: 'internal rate',
        unitType: columnUnitTypes.CURRENCY.value,
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.INTERNAL,
        heatMapSupport: true,
    },
    {
        id: 'internalReportedSpendToDate',
        display: 'Spend To Date',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time',
        displayColumnType: 'spend',
        displayRateType: 'internal rate',
        extensions: [RESOURCE_RATE],
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.INTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'internalReportedSpendFuture',
        display: 'Future Spend',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time',
        displayColumnType: 'spend',
        displayRateType: 'internal rate',
        extensions: [RESOURCE_RATE],
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.INTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'internalReportedSpendAllTime',
        display: 'All Time Spend',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time',
        displayColumnType: 'spend',
        displayRateType: 'internal rate',
        extensions: [RESOURCE_RATE],
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.INTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'billableExternalReportedSpendBetween',
        display: `${displayDateState(dateState, false, false)} Spend (Billable)`,
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time (Billable)',
        displayColumnType: 'spend',
        displayRateType: 'external rate',
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.EXTERNAL,
        heatMapSupport: true,
    },
    {
        id: 'billableExternalReportedSpendPrevious',
        display: `Previous Spend (${displayDateState(dateState, false, false)}) (Billable)`,
        displayTimeType: 'Reported Time (Billable)',
        displayColumnType: 'spend',
        displayRateType: 'external rate',
        unitType: columnUnitTypes.CURRENCY.value,
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.EXTERNAL,
        heatMapSupport: true,
    },
    {
        id: 'billableExternalReportedSpendAfter',
        display: `Next Spend (${displayDateState(dateState, false, false)}) (Billable)`,
        displayTimeType: 'Reported Time (Billable)',
        displayColumnType: 'spend',
        displayRateType: 'external rate',
        unitType: columnUnitTypes.CURRENCY.value,
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.EXTERNAL,
        heatMapSupport: true,
    },
    {
        id: 'billableExternalReportedSpendToDate',
        display: 'Spend To Date (Billable)',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time (Billable)',
        displayColumnType: 'spend',
        displayRateType: 'external rate',
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.EXTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'billableExternalReportedSpendFuture',
        display: 'Future Spend (Billable)',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time (Billable)',
        displayColumnType: 'spend',
        displayRateType: 'external rate',
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.EXTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'billableExternalReportedSpendAllTime',
        display: 'All Time Spend (Billable)',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time (Billable)',
        displayColumnType: 'spend',
        displayRateType: 'external rate',
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.EXTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'billableInternalReportedSpendBetween',
        display: `${displayDateState(dateState, false, false)} Spend (Billable)`,
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time (Billable)',
        displayColumnType: 'spend',
        displayRateType: 'internal rate',
        extensions: [RESOURCE_RATE],
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.INTERNAL,
        heatMapSupport: true,
    },
    {
        id: 'billableInternalReportedSpendPrevious',
        display: `Previous Spend (${displayDateState(dateState, false, false)}) (Billable)`,
        displayTimeType: 'Reported Time (Billable)',
        displayColumnType: 'spend',
        displayRateType: 'internal rate',
        unitType: columnUnitTypes.CURRENCY.value,
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.INTERNAL,
        heatMapSupport: true,
    },
    {
        id: 'billableInternalReportedSpendAfter',
        display: `Next Spend (${displayDateState(dateState, false, false)}) (Billable)`,
        displayTimeType: 'Reported Time (Billable)',
        displayColumnType: 'spend',
        displayRateType: 'internal rate',
        unitType: columnUnitTypes.CURRENCY.value,
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.INTERNAL,
        heatMapSupport: true,
    },
    {
        id: 'billableInternalReportedSpendToDate',
        display: 'Spend To Date (Billable)',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time (Billable)',
        displayColumnType: 'spend',
        displayRateType: 'internal rate',
        extensions: [RESOURCE_RATE],
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.INTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'billableInternalReportedSpendFuture',
        display: 'Future Spend (Billable)',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time (Billable)',
        displayColumnType: 'spend',
        displayRateType: 'internal rate',
        extensions: [RESOURCE_RATE],
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.INTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'billableInternalReportedSpendAllTime',
        display: 'All Time Spend (Billable)',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time (Billable)',
        displayColumnType: 'spend',
        displayRateType: 'internal rate',
        extensions: [RESOURCE_RATE],
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.INTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'nonBillableExternalReportedSpendBetween',
        display: `${displayDateState(dateState, false, false)} Spend (Non-Billable)`,
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time (Non-Billable)',
        displayColumnType: 'spend',
        displayRateType: 'external rate',
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.EXTERNAL,
        heatMapSupport: true,
    },
    {
        id: 'nonBillableExternalReportedSpendPrevious',
        display: `Previous Spend (${displayDateState(dateState, false, false)}) (Non-Billable)`,
        displayTimeType: 'Reported Time (Non-Billable)',
        displayColumnType: 'spend',
        displayRateType: 'external rate',
        unitType: columnUnitTypes.CURRENCY.value,
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.EXTERNAL,
        heatMapSupport: true,
    },
    {
        id: 'nonBillableExternalReportedSpendAfter',
        display: `Next Spend (${displayDateState(dateState, false, false)}) (Non-Billable)`,
        displayTimeType: 'Reported Time (Non-Billable)',
        displayColumnType: 'spend',
        displayRateType: 'external rate',
        unitType: columnUnitTypes.CURRENCY.value,
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.EXTERNAL,
        heatMapSupport: true,
    },
    {
        id: 'nonBillableExternalReportedSpendToDate',
        display: 'Spend To Date (Non-Billable)',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time (Non-Billable)',
        displayColumnType: 'spend',
        displayRateType: 'external rate',
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.EXTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'nonBillableExternalReportedSpendFuture',
        display: 'Future Spend (Non-Billable)',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time (Non-Billable)',
        displayColumnType: 'spend',
        displayRateType: 'external rate',
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.EXTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'nonBillableExternalReportedSpendAllTime',
        display: 'All Time Spend (Non-Billable)',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time (Non-Billable)',
        displayColumnType: 'spend',
        displayRateType: 'external rate',
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.EXTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'nonBillableInternalReportedSpendBetween',
        display: `${displayDateState(dateState, false, false)} Spend (Non-Billable)`,
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time (Non-Billable)',
        displayColumnType: 'spend',
        displayRateType: 'internal rate',
        extensions: [RESOURCE_RATE],
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.INTERNAL,
        heatMapSupport: true,
    },
    {
        id: 'nonBillableInternalReportedSpendPrevious',
        display: `Previous Spend (${displayDateState(dateState, false, false)}) (Non-Billable)`,
        displayTimeType: 'Reported Time (Non-Billable)',
        displayColumnType: 'spend',
        displayRateType: 'internal rate',
        unitType: columnUnitTypes.CURRENCY.value,
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.INTERNAL,
        heatMapSupport: true,
    },
    {
        id: 'nonBillableInternalReportedSpendAfter',
        display: `Next Spend (${displayDateState(dateState, false, false)}) (Non-Billable)`,
        displayTimeType: 'Reported Time (Non-Billable)',
        displayColumnType: 'spend',
        displayRateType: 'internal rate',
        unitType: columnUnitTypes.CURRENCY.value,
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.INTERNAL,
        heatMapSupport: true,
    },
    {
        id: 'nonBillableInternalReportedSpendToDate',
        display: 'Spend To Date (Non-Billable)',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time (Non-Billable)',
        displayColumnType: 'spend',
        displayRateType: 'internal rate',
        extensions: [RESOURCE_RATE],
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.INTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'nonBillableInternalReportedSpendFuture',
        display: 'Future Spend (Non-Billable)',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time (Non-Billable)',
        displayColumnType: 'spend',
        displayRateType: 'internal rate',
        extensions: [RESOURCE_RATE],
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.INTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'nonBillableInternalReportedSpendAllTime',
        display: 'All Time Spend (Non-Billable)',
        unitType: columnUnitTypes.CURRENCY.value,
        displayTimeType: 'Reported Time (Non-Billable)',
        displayColumnType: 'spend',
        displayRateType: 'internal rate',
        extensions: [RESOURCE_RATE],
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        rateType: RATE_TYPE_COLUMNS.INTERNAL,
        heatMapSupport: false,
    },
    {
        id: 'reportedSpendProfitabilityAllTime',
        display: 'Current Spend Profitability All Time',
        displayTimeType: 'Reported Time',
        displayColumnType: 'spend',
        displayRateType: 'external - internal rate',
        extensions: [RESOURCE_RATE],
        unitType: columnUnitTypes.CURRENCY.value,
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        heatMapSupport: false,
    },
    {
        id: 'reportedSpendProfitabilityBetween',
        display: `Spend Profitability ${displayDateState(dateState, false, false)}`,
        displayTimeType: 'Reported Time',
        displayColumnType: 'spend',
        displayRateType: 'external - internal rate',
        extensions: [RESOURCE_RATE],
        unitType: columnUnitTypes.CURRENCY.value,
        columnType: COLUMN_TYPES_ENUM.SPEND,
        timeType: TIME_TYPE_COLUMNS.REPORTED,
        heatMapSupport: false,
    },
];
